import BetSlipService from '@/services/BetSlipService'

const state = () => ({
  positions: [],
  events: [],
  options: [],
  singleStake: 0,
  accumulatorStake: 0,
  totalStake: 0,
  maximumReturn: 0,
  placeable: false,
  placing: false,
  success: null,
  error: null,
  errorList: [],
  fastBet: null,
  fBOn: null,
  quickBet: {
    on: false,
    amount: 100
  }
})

const getters = {
  isFactorSelected: state => (event, factor) => {
    for (let i in state.positions) {
      if (state.positions[i].event.id === event) {
        return state.positions[i].id === factor
      }
    }
    return false
  }
}

const actions = {
  async GET_FASTBET ({ commit }) {
    try {
      const response = await BetSlipService.getFastBet()
      commit('PUT_FASTBET', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async GET_FASTBETON ({ commit }, params) {
    try {
      const response = await BetSlipService.fastBetOn(params)
      commit('PUT_FASTBETON', response.data)
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async PUT_QUICK_BET ({ commit }, params) {
    try {
      commit('PUT_QUICK_BET', params)
    } catch (error) {
      console.log(error)
    }
  },
  async PUT_POSITION ({ commit }, params) {
    try {
      const response = await BetSlipService.position(params)
      commit('PUT_POSITION', response.data.position)
      commit('CLEAR_ERROR_MESSAGE')
      commit('CALCULATE_OPTIONS')
      commit('CALCULATE_AMOUNTS')
      commit('CALCULATE_PLACEABLE')
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  REMOVE_POSITION ({ commit }, event) {
    commit('REMOVE_POSITION', event)
    commit('CLEAR_ERROR_MESSAGE')
    commit('CALCULATE_OPTIONS')
    commit('CALCULATE_AMOUNTS')
    commit('CALCULATE_PLACEABLE')
  },
  async UPDATE_POSITIONS ({ commit, state }) {
    try {
      let positions = []
      for (let i in state.positions) {
        positions.push({
          event: state.positions[i].event.id,
          factor: state.positions[i].id,
          value: state.positions[i].value
        })
      }
      const response = await BetSlipService.update({
        positions: positions
      })
      commit('SET_POSITIONS', response.data)
      commit('CLEAR_ERROR_MESSAGE')
      commit('CALCULATE_OPTIONS')
      commit('CALCULATE_AMOUNTS')
      commit('CALCULATE_PLACEABLE')
    } catch (error) {
      console.log(error.response.data.error)
    }
  },
  async PLACE ({ commit, state }) {
    try {
      commit('SET_PLACING', true)
      let bets = []
      let positions = []
      let maxSystemExpress = 0
      let me = 0
      let e = 0
      let mse = 0
      let value = 1
      for (let i in state.positions) {
        value *= state.positions[i].value
        e += 1
        if (state.positions[i].event.maximumSystemExpress === 0) {
          me += 1
        } else {
          mse = state.positions[i].event.maximumSystemExpress
        }
      }
      if (me === e) {
        maxSystemExpress = 0
      } else {
        maxSystemExpress = +(+mse / (Math.floor((value - 1) * 100) / 100))
      }
      for (let i in state.positions) {
        let position = state.positions[i]
        let requestPosition = {
          event: position.event.id,
          factor: position.id,
          value: position.value,
          maximum: position.event.maximum,
          maximumSystemExpress: maxSystemExpress,
          amount: position.amount
        }
        positions.splice(positions.length, 0, requestPosition)
        if (position.amount === 0) continue
        bets.splice(bets.length, 0, {
          type: 'single',
          amount: position.amount,
          positions: [requestPosition]
        })
      }
      for (let i in state.options) {
        let option = state.options[i]
        if (option.type === 'singles' || option.amount === 0) continue
        let bet = {
          type: option.type,
          amount: option.amount,
          positions: positions
        }
        if (option.type === 'full_cover') {
          bet.value = option.value
        }
        bets.splice(bets.length, 0, bet)
      }
      const response = await BetSlipService.place({
        bets: bets
      })
      if (response.data.success) {
        commit('CLEAR')
        commit('SET_SUCCESS_MESSAGE', response.data.success)
        setTimeout(() => {
          commit('CLEAR_SUCCESS_MESSAGE')
        }, 3000)
      } else if (response.data.error) {
        commit('SET_ERROR_MESSAGE', {
          message: response.data.error,
          list: response.data.errorList ? response.data.errorList : []
        })
        commit('CALCULATE_PLACEABLE')
      } else if (response.data.errors) {
        commit('SET_POSITION_ERRORS', response.data.errors)
        commit('CALCULATE_PLACEABLE')
      }
      commit('SET_PLACING', false)
    } catch (error) {
      console.log(error.response.data.error)
    }
  }
}

const mutations = {
  PUT_FASTBET (state, data) {
    state.fastBet = data.amount
    state.fBOn = data.on
  },
  PUT_FASTBETON (state, data) {
    state.fBOn = data.on
  },
  PUT_QUICK_BET (state, data) {
    state.quickBet.on = data.on
    state.quickBet.amount = data.amount
  },
  PUT_POSITION (state, position) {
    position.invalid = false
    position.amount = state.singleStake
    let index = null
    for (let i in state.positions) {
      if (state.positions[i].event.id !== position.event.id) continue
      index = i
    }
    if (index !== null) {
      state.positions.splice(index, 1, position)
    } else {
      state.positions.splice(state.positions.length, 0, position)
    }
  },
  REMOVE_POSITION (state, event) {
    for (let i in state.positions) {
      if (state.positions[i].event.id !== event) continue
      state.positions.splice(i, 1)
      return
    }
  },
  SET_MAXIMUM (state, position) {
    state.position.amount = state.position.event.maximum
  },
  SET_POSITIONS (state, data) {
    state.positions = data.positions.map(position => { return Object.assign({}, position) })
  },
  CLEAR (state) {
    state.positions = []
    state.options = []
    state.singleStake = 0
    state.accumulatorStake = 0
    state.totalStake = 0
    state.maximumReturn = 0
    state.placeable = false
    state.error = null
    state.errorList = []
    document.querySelector('#page-right-scroll').scrollTop = 0
  },
  CLEAR_ERROR_MESSAGE (state) {
    state.error = null
    state.errorList = []
  },
  CALCULATE_OPTIONS (state) {
    state.options = []
    let length = state.positions.length
    if (length < 2) {
      state.accumulatorStake = 0
      return
    }
    state.options.splice(0, 0, {
      invalid: false,
      amount: state.singleStake,
      type: 'singles',
      code: 'singles',
      name: 'singles',
      nameV: length
    })
    let value = 1
    let maximumSystemExpress = 0
    let me = 0
    let e = 0
    let mse = 0
    for (let i in state.positions) {
      value *= state.positions[i].value
      e += 1
      if (state.positions[i].event.maximumSystemExpress === 0) {
        me += 1
      } else {
        mse = state.positions[i].event.maximumSystemExpress
      }
    }
    if (me === e) {
      maximumSystemExpress = 0
    } else {
      maximumSystemExpress = +(+mse / (Math.floor((value - 1) * 100) / 100))
    }
    state.options.splice(1, 0, {
      invalid: false,
      amount: state.accumulatorStake,
      type: 'accumulator',
      code: 'accumulator_' + length + '_' + length,
      name: 'accumulator',
      nameV: length + '/' + length,
      value: value,
      maximumSystemExpress: maximumSystemExpress
    })
    if (length < 3) return
    for (let i = 2; i < length; i++) {
      state.options.splice(state.options.length, 0, {
        invalid: false,
        amount: 0,
        type: 'full_cover',
        code: 'full_cover_' + i + '_' + length,
        name: 'full-cover-bet',
        nameV: i + '/' + length,
        value: i,
        maximumSystemExpress: maximumSystemExpress
      })
    }
  },
  SET_POSITION_AMOUNT (state, data) {
    for (let i in state.positions) {
      if (state.positions[i].event.id !== data.target) continue
      let position = state.positions[i]
      position.invalid = data.invalid
      position.amount = !data.invalid && data.amount.toString().length ? parseFloat(data.amount) : 0
      state.positions.splice(i, 1, position)
      return
    }
  },
  SET_OPTION_AMOUNT (state, data) {
    for (let i in state.options) {
      if (state.options[i].code !== data.target) continue
      let option = state.options[i]
      option.invalid = data.invalid
      option.amount = !data.invalid && data.amount.toString().length ? parseFloat(data.amount) : 0
      state.options.splice(i, 1, option)
      if (option.type === 'accumulator') {
        state.accumulatorStake = option.amount
      }
      return
    }
  },
  SET_SINGLES_AMOUNT (state, data) {
    let option = state.options[0]
    option.invalid = data.invalid
    option.amount = !data.invalid && data.amount.toString().length ? parseFloat(data.amount) : 0
    state.options.splice(0, 1, option)
    state.singleStake = option.amount
    for (let i in state.positions) {
      let position = state.positions[i]
      position.invalid = option.invalid
      position.amount = option.amount
      state.positions.splice(i, 1, position)
    }
  },
  CALCULATE_AMOUNTS (state) {
    let totalStake = 0
    let maximumReturn = 0
    for (let i in state.positions) {
      if (state.positions[i].invalid || state.positions[i].amount === 0) continue
      totalStake += state.positions[i].amount
      maximumReturn += state.positions[i].amount * state.positions[i].value
    }
    for (let i in state.options) {
      if (state.options[i].invalid || state.options[i].amount === 0) continue
      if (state.options[i].type === 'accumulator') {
        totalStake += state.options[i].amount
        maximumReturn += state.options[i].amount * state.options[i].value
      } else if (state.options[i].type === 'full_cover') {
        totalStake += state.options[i].amount
      }
    }
    state.totalStake = totalStake
    state.maximumReturn = maximumReturn
  },
  CALCULATE_PLACEABLE (state) {
    let placeable = true
    let amounts = 0
    for (let i in state.positions) {
      let position = state.positions[i]
      if (position.invalid || !position.placeable) {
        placeable = false
        break
      }
      if (position.amount > 0) amounts++
    }
    if (placeable) {
      for (let i in state.options) {
        let option = state.options[i]
        if (option.invalid) {
          placeable = false
          break
        }
        if (option.amount > 0) amounts++
      }
    }
    state.placeable = placeable && amounts > 0 /* && !state.error */
  },
  SET_PLACING (state, value) {
    state.placing = value
  },
  ASSEMBLE_BETS (state) {
    let bets = []
    for (let i in state.positions) {
      let position = state.position[i]
      if (!position.placeable || position.amount === 0) continue
      bets.splice(bets.length, 0, {
        type: 'single',
        amount: position.amount,
        positions: [{
          event: position.event.id,
          factor: position.id,
          value: position.value
        }]
      })
    }
    return bets
  },
  SET_SUCCESS_MESSAGE (state, message) {
    state.success = message
  },
  CLEAR_SUCCESS_MESSAGE (state) {
    state.success = null
  },
  SET_ERROR_MESSAGE (state, error) {
    state.error = error.message
    error.list.map(item => {
      state.errorList.splice(state.errorList.length, 0, item)
    })
  },
  SET_POSITION_ERRORS (state, errors) {
    errors.map(error => {
      for (let i in state.positions) {
        let position = state.positions[i]
        if (position.event.id !== error.event) continue
        position.placeable = error.placeable
        position.error = error.message
        if (error.value) {
          position.value = error.value
        }
        state.positions.splice(i, 1, Object.assign({}, position))
      }
    })
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/betSlip.js